// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"159":"8109cae072091d45c5dc","339":"b870c0ea12682a83e69a"}[chunkId] + ".js";
};